import React from "react";
import {VeterinarioObject} from "../../models/Veterinario";
import fb from "../../lib/firebase";
import {EntityList} from "../../components/EntityListNG";
import FormVeterinario from "./FormVeterinarioHOC";
import {cardSubtitle, cardTitle, cardContent} from "./VeterinarioCard";
import {
  IonButtons,
  IonContent,
  IonHeader, IonIcon,
  IonMenuButton,
  IonPage,
  IonTitle,
  IonToolbar, withIonLifeCycle
} from "@ionic/react";
import {filtrarColecao} from "../../lib/utils";
import {AppState} from "../../models/app";
import {AppDispatch, RootState} from "../../global.state";
import {connect} from "react-redux";
import {actions} from "../../lib/app";
import {home} from "ionicons/icons";

interface Props {
  history: any;
  app: AppState;
  dispatch: AppDispatch;
}

interface State {
  loading: boolean;
  colecao: any[];
  colecaoFiltrada: any[];
}

class Veterinarios extends React.Component<Props, State> {
  private cancelListener: () => void;

  constructor(props:Props) {
    super(props);

    this.state = {
      loading: false,
      colecao: [],
      colecaoFiltrada: [],
    };

    this.cancelListener = () => {};
  }

  componentDidMount() {
    this.installListener();
  }
  componentWillUnmount() {
    this.cancelListener();
  }

  installListener = () => {
    this.setState({loading: true});
    const query = fb.db.collection('veterinarios')
      .where('owner', '==', this.props.app.user.uid)
      .orderBy('nome');

    this.cancelListener = query.onSnapshot(snap => {
      const colecao = fb.col(snap).filter((v: any) => v.ativo !== false);
      this.setState({colecao, loading: false});
      this.filtrarColecao();
    });
  };

  filtrarColecao = (criterio:string='') => {
    this.setState({
      colecaoFiltrada: filtrarColecao(this.state.colecao, criterio, 'nome')
    });
  }

  onClickInstance = (instance: VeterinarioObject) => {
    this.props.dispatch(actions.jump('/veterinarios'));
    this.props.history.push(`/veterinarios/${instance.id}/home`);
  };

  render() {
    return (
      <IonPage>
        <IonHeader>
          <IonToolbar color="primary">
            <IonButtons slot="start">
              <IonMenuButton/>
            </IonButtons>
            <IonTitle>
              Veterinários
            </IonTitle>
            <IonIcon
              icon={home}
              slot="primary"
              class="pr-3 text-2xl"
              onClick={() => this.props.history.push('/home')}
            />
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <EntityList
            entityLabel="veterinário"
            colecao={this.state.colecaoFiltrada}
            loading={this.state.loading}
            filtrarColecao={this.filtrarColecao}
            addEnabled={true}
            onClickInstance={this.onClickInstance}
            cardSubTitle={cardSubtitle}
            cardTitle={cardTitle}
            cardContent={cardContent}
            ModelForm={FormVeterinario}
          />
        </IonContent>
      </IonPage>
    );
  }
}

export default connect(({app}: RootState) => ({app}))(withIonLifeCycle(Veterinarios));
